module.exports = __webpack_public_path__ + "img/78.686fbe73.jpg";